import { useMutation } from "@tanstack/react-query";

import { apiClient } from "../cf";

interface SubscriptionCheckoutParams {
  workspaceId: string;
  planSlug: string;
}

export const useSubscriptionCheckoutMutation = () => {
  return useMutation({
    mutationFn: async ({ workspaceId, planSlug }: SubscriptionCheckoutParams) => {
      const res = await apiClient.user.subscription.checkout.$post({
        json: {
          workspaceId,
          planSlug,
          successUrl: `${window.location.origin}/billing?success=true`,
          cancelUrl: `${window.location.origin}/billing?canceled=true`,
        },
      });

      if (!res.ok) {
        throw new Error("Failed to create subscription checkout");
      }

      return res.json();
    },
  });
};
